import services from '@/http'
import * as types from './mutation-types'

export const ActionNewClient = ({ commit }, payload) => (
  services.register.registerClient(payload).then(res => {
    commit(types.NEW_CLIENT, res.data.data)
    return res.status
  })
  .catch(err =>{
    alert('Erro ao cadastrar : ' + err.bodyText)
    return err.status
  })
)